module.exports = __webpack_public_path__ + "img/IMG_8512_P_L_WoodMatted.a1597287.jpg";